import { apificateDate } from '@/helpers/formatDate'
import { _toFixed } from '@/helpers/bigNumber'

export const apificate = (state) => {
  return state.list.map(paymentData => {
    let payment = {}
    // parte común
    payment.dueDate = apificateDate(paymentData.paymentDate)
    payment.amount = _toFixed(paymentData.amount, 2)
    payment.meansType = paymentData.paymentMethod
    payment.paymentReconciliationReference = paymentData.paymentReconciliationReference
    payment.debitReconciliationReference = paymentData.debitReconciliationReference
    payment.regulatoryReportingData = paymentData.regulatoryReportingData
    payment.additionalInformation = paymentData.additionalInformation
    let accountDebited = {}
    accountDebited.iban = paymentData.ibanDebited
    payment.accountDebited = accountDebited
    let accountCredited = {}
    accountCredited.iban = paymentData.ibanCredited
    payment.accountCredited = accountCredited
    return payment
  })
}

export const getDetails = (state) => {
  return state.list.map((paymentData) => {
    return {
      paymentData,
      _showDetails: false
    }
  })
}

export const getPaymentList = (state) => {
  return state.list
}

export const getDocumentByKey = state => key => {
  return state.list.find(payment => payment.key === key)
}
